import { useEffect, useState } from "react";
import { ShowHideEPR } from "../ShowHideEPR";
import DIYCardExtended from "../EPRPackagesCard/DIY";
import "./index.css";
import { AlertV3 } from "../../../../../components/Alert";
import { CheckoutForm } from "../../../../../components/CheckoutForm";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";
import { getProfile } from "../../../../../apis/User";

const DIYCard = () => {
  const [show, setShow] = useState(false);
  const [upgradePlan, setUpgradePlan] = useState(false);
  const [email, setEmail] = useState("");
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
  useEffect(() => {
    getProfile({ setEmail: setEmail });
  }, []);
  return (
    <>
      {!show ? (
        <div
          className="card-container-epr blue-container"
          onClick={() => setUpgradePlan(true)}
        >
          <div
            className="card-box-content-epr epr-content-blue"
            style={{ padding: "8px 15px" }}
          >
            <p style={{ color: "white", fontSize: "16px" }}>Do It Yourself</p>
          </div>
          <div
            className="card-box-content-epr epr-content-blue"
            style={{ padding: "8px 15px" }}
          >
            <p style={{ color: "white", fontSize: "14px", fontWeight: "bold" }}>
              650,-DKK
            </p>
          </div>
          <div
            className="card-box-content-epr epr-content-white"
            style={{ padding: "4px 10px" }}
          >
            <p style={{ color: "#09366B", fontSize: "12px" }}>
              /month/employee*
            </p>
          </div>
          <div
            className="card-box-content-epr epr-content-white"
            style={{ padding: "4px 12px" }}
          >
            <p style={{ color: "#09366B", fontSize: "10px" }}>
              annual cost 7,800 DKK ex VAT*
            </p>
          </div>
          <ShowHideEPR show={show} setShow={setShow} />
        </div>
      ) : (
        <DIYCardExtended
          show={show}
          setShow={setShow}
          onClick={() => setUpgradePlan(true)}
        />
      )}
      <AlertV3
        open={upgradePlan}
        title={"Payment Form"}
        body={
          <Elements stripe={stripePromise}>
            <CheckoutForm
              email={email}
              handleClose={() => setUpgradePlan(false)}
              price={650}
            />
          </Elements>
        }
        decline={() => setUpgradePlan(false)}
      />
    </>
  );
};

export default DIYCard;
